import React from 'react';
import PropTypes from 'prop-types';

function FreeShippingTierInfoModal({ lang, t, idSuffix }) {
    return (
        <div id={`free-shipping-tier-info-modal${idSuffix}`} className="free-shipping-tier-info-modal modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="free-shipping-tier-info-modal__dialog modal-dialog modal-sm mx-auto" role="document">
                <div className="modal-content p-4">
                    <button type="button" className="free-shipping-tier-info-modal__close-btn close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body p-0">
                        <iframe className="free-shipping-tier-info-modal__iframe w-100 border-0" src={`/${lang}/free-shipping-tier-info`} />
                    </div>
                    <div className="modal-footer p-0 justify-content-center">
                        <button type="button" className="free-shipping-tier-info-modal__textual-close-btn btn btn-primary font-weight-bold" data-dismiss="modal">
                            {t('footer.common_freeshippingtierinfomodal_buttontext', 'Okay')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

FreeShippingTierInfoModal.defaultProps = {
    idSuffix: '',
};

FreeShippingTierInfoModal.propTypes = {
    lang: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    idSuffix: PropTypes.string,
};

export default FreeShippingTierInfoModal;



// WEBPACK FOOTER //
// ./src/Common/FreeShippingTierInfoModal.js